import React from 'react';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/acai.css';

const LogModal = ({
  modalType,
  olds,
  news, 
  onClose
}) => {
  const getTypeTitle = () => {
    switch(modalType) {
      case 'steps':
        return 'Steps';
      case 'faqs':
        return 'FAQs';
      case 'questDescriptions':
        return 'Quest Descriptions';
      case 'whitelist':
        return 'Whitelist';
      case 'tags':
        return 'Tags';
      case 'viewerTiers':
        return 'Viewer Tiers';
      case 'memberTiers':
        return 'Member Tiers'; 
      case 'blocks':
        return 'Blocks';
      case 'stepsPage1':
        return 'User Information (Page 1)';
      case 'stepsPage2':
        return 'User Information (Page 2)';
      case 'stepsPage3':
        return 'User Information (Page 3)';
      case 'questTags':
        return 'Quest Tags';
      case 'requirements':
        return 'Requirements';
      case 'splitTiers':
        return 'Split Tiers';
      case 'rankTiers':
        return 'Rank Tiers';
      default:
        return '';
    }
  };

  const typeTitle = getTypeTitle();

  return (
    <section className="ModalQuestLogs">
      <section className="ModalMaster">
        <section className="Modal Modal__ModalQuestLogs active">
          <div 
            className="Modal__layer"
            onClick={onClose}
            aria-hidden
          />
          <section className="Modal__wrapper">
            <div
              className="Modal__close-btn"
              onClick={onClose}
              aria-hidden
            />
            <div className="ModalQuestLogs__body">
              <div className="ModalQuestLogs__olds">
                <div className="ModalQuestLogs__olds__title">
                  Old {typeTitle}
                </div>
                <div className="ModalQuestLogs__olds__row">
                  <JSONPretty data={olds} />
                </div>
              </div>
              <div className="ModalQuestLogs__news">
                <div className="ModalQuestLogs__news__title">
                  New {typeTitle}
                </div>
                <div className="ModalQuestLogs__news__row">
                  <JSONPretty data={news} />
                </div>
              </div>
            </div>
            <div className="ModalQuestLogs__footer">
              <div className="ModalQuestLogs__footer__button">
                <div
                  className="ModalQuestLogs__footer__buttonA"
                  onClick={onClose}
                  aria-hidden
                >
                  Close
                </div>
              </div>
            </div>
          </section>
        </section>
      </section>
    </section>
  );
};

export default LogModal;